module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/fluent-app-icon-5.40269ecd.png";